import React, { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { alFineSessioneDipendente, studioDelDipendenteNonInRegola } from '../../services/fineSessioneDipendente';
import { MESSAGGIO_STUDIO_NON_IN_REGOLA } from '../../utils/sessioneAssociato';

/**
 * Studio del dipendente non in regola (403 `STUDIO_NON_IN_REGOLA`, Ruling R16): parte dallo stato
 * già noto e si accende al primo 403 che arriva. Il setter serve alla dashboard per spegnerlo
 * quando `/auth/me` torna valida.
 */
export function useStudioNonInRegola(): [boolean, React.Dispatch<React.SetStateAction<boolean>>] {
  const [chiuso, setChiuso] = useState<boolean>(() => studioDelDipendenteNonInRegola());
  useEffect(
    () =>
      alFineSessioneDipendente((motivo) => {
        if (motivo === 'studio_non_in_regola') setChiuso(true);
      }),
    []
  );
  return [chiuso, setChiuso];
}

/** Avviso della dashboard al posto delle card delle sezioni. */
const AvvisoStudioNonInRegola: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div
    role="status"
    className={`flex items-start gap-3 rounded-xl border border-amber-300 bg-amber-50 p-4 text-sm text-amber-900 dark:border-amber-700 dark:bg-amber-900/20 dark:text-amber-200 ${className}`}
  >
    <AlertTriangle className="mt-0.5 h-5 w-5 flex-shrink-0" aria-hidden="true" />
    <p className="font-medium">{MESSAGGIO_STUDIO_NON_IN_REGOLA}</p>
  </div>
);

export default AvvisoStudioNonInRegola;
